import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Button, Col, Collapse, Row } from 'reactstrap'

const InfluenzaFaq = () => {

    const [open1,setOpen1] = useState(false)
    const [open2,setOpen2] = useState(false)
    const [open3,setOpen3] = useState(false)
    const [open4,setOpen4] = useState(false)
    const [open5,setOpen5] = useState(false)
    const [open6,setOpen6] = useState(false)

    const handleToggle1 = () => {
        setOpen1(!open1)
        console.log(open1)
    }

    const handleToggle2 = () => {
        setOpen2(!open2)
        console.log(open2)
    }

    const handleToggle3 = () => {
        setOpen3(!open3)
        console.log(open3)
    }

    const handleToggle4 = () => {
        setOpen4(!open4)
        console.log(open4)
    }

    const handleToggle5 = () => {
        setOpen5(!open5)
        console.log(open1)
    }

    const handleToggle6 = () => {
        setOpen6(!open6)
        console.log(open2)
    }


  return (
    <div id='website-responsive' style={{ backgroundColor:'#' }}>

{/* <div className='left-padding7rem1 right-padding7rem1 pt-5' style={{ marginTop:'', marginLeft:'' }}>
            <text className='fs-ss-30-1 text-ss-primary fw-800 text-raleway' style={{ letterSpacing:'0.9px'   }}>
                Frequently Asked Questions
            </text>
        </div> */}

        <Row className=''>
            <Col xs='12' md='12' lg='' className=''>
            <section className='' style={{ backgroundColor:'#f2f2f2'}}>

<div className='left-padding7rem1 right-padding5rem1'>

    <div className='row mt-' id="faq-home">

        <div className='col-md-12 pb-md5 pt-md3 pb4 p-top-bottom2rem' style={{borderRadius:"", border:''}}>
            <div className='pb-4'>
                <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                    FAQs
                </div>
                <hr className='hr-style my-md-' style={{ width:'50px', marginTop:'2px', marginBottom:'4px'}}/>
            </div>

            <Accordion className='borde' style={{ borderRadius:'0px', border:'none', backgroundColor:'#f2f2f2' }}>

                <AccordionItem style={{ backgroundColor:'#f2f2f2', border:'', }} eventKey="0" >

                    <AccordionHeader onClick={() => handleToggle1()} style={{ color:'#f2f2f2'}}>

                        <span className='fs-ss-16 text-ss-black fw-700 text-montserrat p-2' style={{fontWeight:"600"}}>
                        When is flu season in the US?
                        </span>

                    </AccordionHeader>

                    <Collapse  isOpen={open1  ? true : false}>
                    <AccordionBody className='p1' style={{ borderBottom:'1px solid black', color:'#f2f2f2'}}>

                        <span className='fs-ss-15 text-montserrat fw-600 text-ss-black'>

                        Although the flu season typically occurs in the fall and winter in the United States, Influenza viruses also spread throughout the year. Flu activity typically peaks between December and February.
                        </span>

                    </AccordionBody>
                </Collapse>
                </AccordionItem>




                <AccordionItem style={{ backgroundColor:'#f2f2f2', border:'', }} eventKey="1" >

                    <AccordionHeader onClick={() => handleToggle2()} style={{ backgroundColor:'f2f2f2'}}>

                        <span className='fs-ss-16 text-ss-black fw-700 text-montserrat p-2' style={{fontWeight:"600"}}>

                        Do I need any preparation before being tested for flu?
                        
                        </span>

                    </AccordionHeader>
                    <Collapse isOpen={open2 === true ? true : false}>
                    <AccordionBody className='p1' style={{ borderBottom:'1px solid black'}}>

                        <span className='fs-ss-15 text-montserrat fw-600 text-ss-black'>

                        A flu test does not require any special preparations on your part. Flu tests are also used to monitor community flu outbreaks and determine the type of flu virus that causes the illness.

                        </span>

                    </AccordionBody>
                    </Collapse>
                </AccordionItem>




                <AccordionItem style={{ backgroundColor:'#f2f2f2', border:'1px solid #d4d4d4', }} eventKey="2" className=''>

                    <AccordionHeader onClick={() => handleToggle3()}>

                        <span className='fs-ss-16 text-ss-black fw-700 text-montserrat p-2' style={{fontWeight:"600"}}>

                        Are influenza tests painful?
                        
                        </span>

                    </AccordionHeader>
                    <Collapse isOpen={open3 === true ? true : false}>
                    <AccordionBody className='p1' style={{ borderBottom:'1px solid black'}}>

                        <span className='fs-ss-15 text-montserrat fw-600 text-ss-black'>
                        You might gag or even get a tickle when your nose is swabbed during Flu test in Chicago. An aspirate or wash for the nose may be uncomfortable but these effects are short-lived.
                        </span>

                    </AccordionBody>
</Collapse>
                </AccordionItem>

                <AccordionItem style={{ backgroundColor:'#f2f2f2', border:'1px solid #d4d4d4', }} eventKey="2" className=''>

                <AccordionHeader onClick={() => handleToggle4()}>

                    <span className='fs-ss-16 text-ss-black fw-700 text-montserrat p-2' style={{fontWeight:"600"}}>
                        Where should I get tested for flu in Chicago?
                    </span>

                </AccordionHeader>
                <Collapse isOpen={open4 === true ? true : false}>
                <AccordionBody className='p1' style={{ borderBottom:'1px solid black'}}>

                    <span className='fs-ss-15 text-montserrat fw-600 text-ss-black'>
                            You can get influenza tests from United Lab Care. We provide reliable and rapid flu testing services in Chicago.
                    </span>

                </AccordionBody>
                </Collapse>
                </AccordionItem>

                <AccordionItem style={{ backgroundColor:'#f2f2f2', border:'1px solid #d4d4d4', }} eventKey="2" className=''>

                <AccordionHeader onClick={() => handleToggle5()}>

                    <span className='fs-ss-16 text-ss-black fw-700 text-montserrat p-2' style={{fontWeight:"600"}}>

                    Do you offer flu shots or vaccination for influenza?
                
                    </span>

                </AccordionHeader>
                <Collapse isOpen={open5 === true ? true : false}>
                <AccordionBody className='p1' style={{ borderBottom:'1px solid black'}}>

                    <span className='fs-ss-15 text-montserrat fw-600'>
                        No, we do not offer vaccination or flu shot at United Lab Care.
                    </span>

                </AccordionBody>
                </Collapse>
                </AccordionItem>
{/* 
                <AccordionItem style={{ backgroundColor:'#f2f2f2', border:'1px solid #d4d4d4', }} eventKey="2" className=''>

                <AccordionHeader onClick={() => handleToggle6()}>

                    <span className='fs-ss-16 text-ss-black fw-700 text-montserrat p-2' style={{fontWeight:"600"}}>

                    What is the Visit Schedule for Well-Children?
                    
                    </span>

                </AccordionHeader>
                <Collapse isOpen={open6 === true ? true : false}>
                <AccordionBody className='p1' style={{ borderBottom:'1px solid black'}}>

                    <span className='fs-ss-16 text-roboto'>
                    <text className='fs-ss-16 text-roboto fw-700'>The visit schedule for well children is as follows:</text><br/><br/>

Right after birth <br/>
1 month <br/>
2 months <br/>
4 months <br/>
6 months <br/>
9 months <br/>
12 months <br/>
15 months<br/>
18 months <br/>
2 years <br/>
3 years <br/>
4 years <br/>
5-10 years <br/>
11 years <br/>
12-15 years <br/>
16 years <br/>
17-18 years <br/> <br/>

For more information, visit; well visits page.
                    </span>

                </AccordionBody>
                </Collapse>
                </AccordionItem> */}

                </Accordion> 
                </div>
                </div>
                </div>
                </section>
                
                </Col>

            <Col xs='12' md='12' lg='5' className='flex-center pt-md-4 py-4'>
                <div className='flex-center'>
                    <img src='influenza-testing/Influenza-Testing-img3.png' alt='' className='img-w16-1'  />
                </div>
            </Col>
         
        
        </Row> 

         <div className='py-md-5 pb-5 pt-3  left-padding7rem right-padding7rem'>
            <div className='left-padding8rem right-padding8rem py-md-4' style={{ }}>
                <div className='bg-img rounded30 pt-md-4' style={{ boxShadow:'0 0 10px 0 rgba(0,0,0,.5)', backgroundImage:'url("sti-testing/RSV-Testing-bg2.png")', width:'100%'}}>
                    <div className='p-4'>
                    <text className='fs-ss-26-5 text-montserrat text-white fw-600 lh-1-2'>
                        <center>
                            Ultimate Destination for Lab Testing In Chicago
                            <div className='pt-2'>
                            <hr className='hr-style my-md-2' style={{ width:'120px', marginTop:'2px', marginBottom:'4px'}}/>
                            </div>
                        </center>
                    </text>    
                    </div>

                    <div className='pb-4 pt-md-'>
                        <center>
                        <Link to='/book-panel-test-appointment'>
                            <Button className='btn-ss-secondary rounded20 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                                <text className='text-montserrat fw-600 fs-ss-16-1' style={{ padding:'',}}>
                                    Book Appointment
                                </text>
                            </Button>
                        </Link>
                        </center>
                    </div>
                </div>
            </div>
            </div>      
    </div>
  )
}

export default InfluenzaFaq